import MuiInputLabel, { InputLabelProps } from '@mui/material/InputLabel';

export interface IInputLabelProps extends InputLabelProps {}

const InputLabel = (props: IInputLabelProps): JSX.Element => {
  return <MuiInputLabel {...props} />;
};

export default InputLabel;
